import './TvButton.css';
import { Button } from '../../components/Button';
import { t } from '../../copy/strings';
import { enterTv } from '../../state/actions';
import { useConfig, useLayout, useTvOn } from '../../state/hooks';

const PHONE = new Set(['flow', 'tablet', 'land']);

/**
 * "Tela cheia" (§6.8): `Button` padrão com o ícone `expand`; ≤ 1520 só o ícone (36×36), com o nome acessível
 * preservado. O clique chama `enterTv()`, que pede a tela cheia de forma síncrona e não escreve `tv=1` (§5.2.7).
 * Oculto com `features.tv=false`, no celular e na TV (lá entra o TvExitButton, §12.1). O TopBar só o monta a partir da
 * Fase 11 (§17.2 Fase 2b item 5).
 */
export function TvButton() {
  const enabled = useConfig().features.tv;
  const mode = useLayout().mode;
  const tv = useTvOn();
  if (!enabled || tv || PHONE.has(mode)) return null;
  return (
    <span class="tv-button" data-testid="tv-button">
      <Button
        label={t('tv.button')}
        icon="expand"
        collapsibleLabel
        title={t('tv.button.title')}
        onClick={() => enterTv()}
      />
    </span>
  );
}
